import { render, staticRenderFns } from "./TrTermsOfUse.vue?vue&type=template&id=2c922548&scoped=true"
import script from "./TrTermsOfUse.vue?vue&type=script&lang=js"
export * from "./TrTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2c922548",
  null
  ,true
)

export default component.exports